import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLogged: !!localStorage.getItem('token'),
    lastUpdate: localStorage.getItem('lastUpdate')? Date.parse(localStorage.getItem('lastUpdate')): false,
    userInfo: localStorage.getItem('user')? JSON.parse(localStorage.getItem('user')): null,
    userSocketData: null,
    unsynced: 0,
    gps_pos: localStorage.getItem('gps_pos')? localStorage.getItem('gps_pos'): '0:0',
    statuses: [],
    lastStatus: null,
  },
  mutations: {
    LOGIN_USER (state) {
      state.isLogged = true;
      state.userInfo = null;
      state.userSocketData = null;
    },
    LOGOUT_USER (state) {
      state.isLogged = false
    },
    DO_UPDATE (state) {
      state.lastUpdate = new Date();
      localStorage.setItem('lastUpdate', state.lastUpdate);
    },
    UPDATE_USER_INFO (state, data) {
      console.log('upate user info', data);
      state.userInfo = data;
    },
    UPDATE_EXT_STATUS (state, data) {
      console.log('update ext status', data);
      state.userSocketData.status = data;
      console.log(state.userSocketData.status);
      if(data == "0") {
        state.userSocketData.peerstatus = "Registered";
      }
    },
    GPS_UPD (state, pos) {
      state.gps_pos = pos;
    },
    SET_UNSYNCED (state, n) {
      state.unsynced = n;
    },
    SOCKET_CONNECTION_INITIALIZED(state, message) {
      console.log('SOCKET_CONNECTION_INITIALIZED' , message);
      if(message[state.userInfo.station]) {
        state.userSocketData = message[state.userInfo.station];
      }
      console.log('userSocketData', state.userSocketData);
    },
    SOCKET_BLB_EVENT(state, message) {
      if(state.userInfo.station == message.exten || state.userInfo.station == message.calleridname || message.event == "Bridge") {
        state.lastStatus = message;
        console.log('SBS event', message);
      }

    },
    CLEAR_STATUSES (state) {
      state.statuses = [];
    }
  },
  actions: {
    LOAD_USER_INFO: function ({ commit }) {

    },
  },
  getters: {
    isLoggedIn: state => {
      return state.isLogged
     }
  }
})
